/* eslint-disable */
import React, { Component } from 'react'
import { View, Text, Image, TouchableOpacity } from 'react-native'
import { getAvatar } from '../Lib/utils'
import {Fonts} from '../Themes'
import Images from "../Themes/Images"

/*
const DeleteComponent = (props) =>
  <TouchableOpacity style={{ width : 25, height : 25, backgroundColor : 'red', borderRadius : 12.5, marginRight : 25, flexDirection : 'row', alignItems : 'center', justifyContent : 'center' }}
                    activeOpacity={0.5} onPress={props.delete}>
    <View style={{ height : 3, width : 15, backgroundColor : 'white' }}></View>
  </TouchableOpacity>
*/
const DeleteComponent = (props) =>
    <TouchableOpacity style={{ width : 25, height : 25, marginRight : 5, flexDirection : 'row', alignItems : 'center', justifyContent : 'center' }}
                      activeOpacity={0.5} onPress={props.delete}>
      <Image
        style={{ width: 9, height: 9 }}
        resizeMode="cover"
        source={Images.deleteBtn} />
    </TouchableOpacity>


export default class HashtagComponent extends Component {
  constructor(props) {
    super(props)
  }

  render( ) {
    let data = this.props.data
    if (!data) 
     return (
      <View style={{ flexDirection : 'row', justifyContent: 'flex-start', backgroundColor : 'white'
                  , height : 50, width : '100%', alignItems : 'center' }}/>
    )
    else
     return (
      <View style={{ flexDirection : 'row', justifyContent: 'flex-start', backgroundColor : 'white'
                  , height : 50, width : '100%', alignItems : 'center' }}>

        { this.props.editable && <DeleteComponent tag={data} delete={( ) => this.props.delete(data)}/> }

        <TouchableOpacity style={{marginLeft: 10}} activeOpacity={0.5} onPress={( ) => this.props.navigation.navigate('explora', { hashTag : data })}>
          <Text style={{ fontFamily : Fonts.style.font.bold, color : 'black', fontSize : 14 }}>#{data}</Text>
        </TouchableOpacity>

      </View>

    )
  }
}
